module.exports = __webpack_public_path__ + "img/orange_104.3c5fd295.png";